import { rem } from 'polished'
import { memo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { AccommodationPolicyDescription } from 'components/AccommodationKit/AccommodationAmenitiesAndPoliciesContent'
import BodyText from 'LuxKit/Typography/BodyText'

const DetailsDescription = styled(AccommodationPolicyDescription)`
  margin-top: ${rem(12)};
`

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`

const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(8)};
`

interface Props {
  pkg: App.Package
}

function RoomDetails(props: Props) {
  const intl = useIntl()
  const { pkg } = props

  const roomFacilitiesLabel = intl.formatMessage({
    id: 'CadMWPEJme5nvvitcGnP',
    defaultMessage: 'Room facilities:',
    description: 'Heading for room facilities list in accommodation summary',
  })
  const roomPoliciesLabel = intl.formatMessage({
    id: 'Sn0S_2S6aaTlv7cmaAES',
    defaultMessage: 'Room policies:',
    description: 'Heading for room policies section in accommodation summary',
  })

  return (
    <Container>
      <Section>
        <BodyText variant="medium" weight="bold">
          {roomFacilitiesLabel}
        </BodyText>
        {pkg.roomType?.amenities.map((amenity) => (
          <BodyText as="li" variant="small" key={amenity.id}>
            {amenity.description}
          </BodyText>
        ))}
      </Section>
      {pkg.roomPolicyDescription && (
        <Section>
          <BodyText variant="medium" weight="bold">
            {roomPoliciesLabel}
          </BodyText>
          <DetailsDescription
            fontSize="medium"
            policyDescription={pkg.roomPolicyDescription}
            type="compact"
          />
        </Section>
      )}
    </Container>
  )
}

export default memo(RoomDetails)
